__turbopack_context__.v({
  "chartCell": "chart-module__q7hJvq__chartCell",
  "chartRowLabel": "chart-module__q7hJvq__chartRowLabel",
  "chartScroll": "chart-module__q7hJvq__chartScroll",
  "chartSeasonLabel": "chart-module__q7hJvq__chartSeasonLabel",
  "chartSwatch": "chart-module__q7hJvq__chartSwatch",
  "chartTable": "chart-module__q7hJvq__chartTable",
  "ctaBand": "chart-module__q7hJvq__ctaBand",
  "ctaBandSlim": "chart-module__q7hJvq__ctaBandSlim",
  "ctaHeadline": "chart-module__q7hJvq__ctaHeadline",
  "ctaSubtitle": "chart-module__q7hJvq__ctaSubtitle",
  "hairline": "chart-module__q7hJvq__hairline",
  "heroKicker": "chart-module__q7hJvq__heroKicker",
  "heroTagline": "chart-module__q7hJvq__heroTagline",
  "heroTitle": "chart-module__q7hJvq__heroTitle",
  "kicker": "chart-module__q7hJvq__kicker",
  "sectionTitle": "chart-module__q7hJvq__sectionTitle",
  "serif": "chart-module__q7hJvq__serif",
  "swatchCircle": "chart-module__q7hJvq__swatchCircle",
  "swatchItem": "chart-module__q7hJvq__swatchItem",
  "swatchName": "chart-module__q7hJvq__swatchName",
  "swatchRow": "chart-module__q7hJvq__swatchRow",
});
